export const DCB_TAB_TYPES = {
    DATA: 'data',
    FILE: 'file',
    TABLEAU: 'tableau',
    TEXT: 'text',
    DASHBOARD: 'dashboard',
    FUNCTION: 'function' // added forcefully
}

export const DCB_VIEW_TYPES = {
    NARRATIVE: 'Narrative',
    CHART: 'Chart',
    TABLE: 'Data',
    FILE: 'File',
    REPORT: 'Report'
}

export const DCB_CONTEXT_COMMANDS = {
    SET_CONTEXT: 'set context',
    RESET_CONTEXT: 'reset context'
}

export const DCB_CHART_TYPES = {
    FULL_SYSTEM: 'full_system',
    SYSTEM: 'system',
    BAR: 'bar',
    LINE: 'line',
    SCATTER: 'scatter',
    STACKED_HORIZONTAL_BAR: 'stacked_hbar'
}

export const DCB_HIGHLIGHT_TYPES = {
    REPORTS: 'reports',
    DIMENSIONS: 'dimensions',
    MEASURES: 'measures',
    BREAKDOWNS: 'breakdowns',
    CALCULATIORS: 'calculators',
    ANALYTICS: 'analytics'
}

export const DCB_DASHBOARD = {
    CHART: {
        TYPE: {
            TREEMAP: 'treemap',
            MIXED: 'mixed',
            GAUGE: 'gauge',
        }
    },
    TOGGLE: {
        TYPE: {
            DROPDOWN: 'dropdown',
            MULTIDROPDOWN: 'multidropdown',
            DATERANGEPICKER: 'daterangepicker',
        }
    },
    DATA: {
        TYPE: {
            SINGLE: 'single',
            BUTTON: 'button',
            TABLE: 'table',
        },
        CALCULATION: {
            DIVISION: 'division',
            ADDITION: 'addition',
            SUBTRACTION: 'subtraction',
            MULTIPLICATION: 'multiplication',
            NUMBER: 'number',
            SUM: 'sum',
            AVG: 'avg',
            COUNT: 'count',
        }
    },
    CLASS: {
        TYPE: {
            CHART: 'chart',
            TOGGLE: 'toggle',
            DATA: 'data',
            TAB: 'tab',
            TABHOLDER: 'tab holder',
        }
    }
};

export const DCB_AGGREGATE_FUNCTION = {
    SUM: 'sum',
    AVG: 'avg',
    SUM_DIVIDE: 'sum-divide',
    COUNT: 'count'
};
